import React from 'react';
import { Container } from 'reactstrap';
import { mind_pattern_sections } from '../../../core/constants'
import { Disclaimers } from '../common';
import ReactGA from 'react-ga';
import { trackingActions } from '../../../core/tracking';
import { useDispatch } from 'react-redux';

const Start = (props) => {

  const dispatch = useDispatch()
  const { hanndleNext, user, retake, areas } = props;
  
  const eventGA = () => {
      !retake ?
        ReactGA.event({
            category: 'Mind Patterns',
            action: 'Creation started'
        })
      :
        ReactGA.event({
            category: 'Mind Patterns',
            action: 'Retake assessment'
        })
  }
  const ourTracking = () => {
      !retake ?
      dispatch(trackingActions.saveTrackingEvent({category: 'Mind Patterns', action: 'Creation started'}))
      :
      dispatch(trackingActions.saveTrackingEvent({category: 'Mind Patterns', action: 'Retake assessment'}))
  }

  return (
    <>
      <div className='w-100'>
      <Container fluid="md" className='mx-auto p-0'>
        <div className='pt-md-3 px-md-3 rounded border-md'>
          <h1 className='mb-2 libre-caslon-text-regular h3-md h4'>Mind Patterns</h1>
          <p className='mb-3'><strong>Recognizing your Mind Pattern</strong></p>
          <p className='mb-3'>You may have heard people describe themselves as either "visual", "auditory" or "hands-on" learners, but this is an oversimplification; they're describing how they trigger their focus or how they concentrate. However, your ability to focus is only one part of how you effectively think, learn and communicate: In total, there are three different states of attention: </p>
          <p className='mb-3'>Focus (concentration), Sorting (decision-making) and Open (imagination).</p>
          <p className='mb-3'>Each of these states of attention is catalyzed by a different input or channel — either auditory, kinesthetic, and visual.</p>
          <p className='mb-3'><strong>Matching these three inputs with the three states of attention produces your unique Mind Pattern, which this assessment will help you determine. Following the assessment, you'll understand the characteristics of your Mind Pattern and its associated strengths and challenges.</strong></p>

          <div className="d-flex align-items-center justify-content-center mb-3">
            {areas.items.map((area)=> 
              <div key={area.id} className={`mx-2 rounded-circle bg-${area.name.toLowerCase()} p-3`}>
                <img src={area.icon} alt={area.name} width="40" height="auto" className={`${area.name.toLowerCase() !== 'auditory' ? 'icon-inverse' : ''}`}/>
              </div>
            )}
          </div>

          <div className='rounded p-2 border border-ice-70 bg-ice-40 mb-4'>
            <p className='small mb-0'><strong>Ready?</strong> The following discovery consists of 14 questions, each with three choices. Take your time to select the answer that is most true for you. Just answer each question as truthfully as possible without thinking too hard about them.</p>
          </div>

          <p className='text-orange small mb-4'><i>Please note that answers are not saved until the assessment is completed. If you exit the assessment prior, you will need to retake it.</i></p>

          {user.assessment_access === 2 && !user.talents ? null :
            <button onClick={() => {hanndleNext(mind_pattern_sections.ASSESSMENT); eventGA(); ourTracking() }} className="btn btn-green-light btn-sm mx-auto px-3 d-block mb-5">
              <i className="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19" style={{ marginBottom: '2px'}}>
                    <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z"/>
                </svg>
              </i>
              Start Assessment
            </button>
          }

          <Disclaimers view="propiedad-intelectual" />
        </div>
      </Container>
      </div>
    </>
    )
}

export default Start;
